import { recurrenceTypes, monthlyOptionsTypes } from '../constants';

import { cronPlaces } from './constants';

export const getCronExpessionFromOptions = options => {
  let results = ['*', '*', '*', '*', '*', '*'];

  if (options.recurrenceType === recurrenceTypes.NONE) {
    return null;
  }

  results[cronPlaces.MONTHLY] = (options.recurrenceType !== recurrenceTypes.MONTHLY) ? '?' : getMonthPlaceHolder(options);
  results[cronPlaces.WEEKLY] = (options.recurrenceType === recurrenceTypes.MONTHLY) ? '?' : getWeeklyPlaceHolder(options);

  if (options.time) {
    results[cronPlaces.HOUR] = options.time.hour || '*';
    results[cronPlaces.MIN] = options.time.minute || '*';
    results[cronPlaces.SEC] = options.time.second || '*';
  }

  return results.join(' ');
};

const getWeeklyPlaceHolder = options => {
  let placeHolder = '*';

  if (options.recurrenceType !== recurrenceTypes.WEEKLY) {
    return placeHolder;
  }

  return Array.isArray(options.value) && options.value.length > 0
    ? options.value.join(',')
    : '*';
};

const getMonthPlaceHolder = options => {
  let placeHolder = '*';

  if (options.recurrenceType !== recurrenceTypes.MONTHLY) {
    return placeHolder;
  }

  if (options.modifier === monthlyOptionsTypes.DAYS_BEFORE_END) {
    placeHolder = `L-${options.value && options.value >= 1 &&  options.value <= 31 && !isNaN(options.value)  ? parseInt(options.value) : 1}`;
  }
  if (options.modifier === monthlyOptionsTypes.LAST_DAY) {
    placeHolder = 'L';
  }
  if (options.modifier === monthlyOptionsTypes.ON_DAY) {
    placeHolder = options.value && options.value >= 1 && options.value <= 31 && !isNaN(options.value) ? parseInt(options.value) : 1;
  }

  return placeHolder;
};
